var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"view-button-celestialclose icon",class:_vm.className},[_c('img',{attrs:{"src":require("@/Asset/image/icon/celestial-close.svg"),"alt":"Close"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }